/**
 * 請求・収納API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 請求先住所情報Dto
 */
export interface Szme004aResponseClmtoClaimInfGetInfDtoVisitInf01DtoVisitAddrInfDto { 
    /**
     * 郵便番号：数字
     */
    postno?: string;
    /**
     * 表示住所漢字：全角
     */
    sazvjjsKanjiAname?: string;
    /**
     * 住宅・棟号漢字テキスト：全角
     */
    supadrKanjiAname1?: string;
    /**
     * 屋号・業種・目標（漢字）：全角
     */
    yagyomoKanji?: string;
    /**
     * 住所管理番号：数字
     */
    addrMno?: string;
}

